<h4>{{'SELECT_RESPONSIBLE'| translate}}</h4>
<mat-dialog-content fxLayout="column" fxLayoutGap="8px">
  <div *ngFor="let up of userprofiles"
       mat-dialog-close="{{up.id}}"
       class="userprofile">
    {{up.user.firstName}} {{up.user.lastName}}
  </div>
</mat-dialog-content>
